var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card-actions",
        {
          attrs: {
            "show-loading": _vm.saving || _vm.fetching,
            "action-collapse": "",
            "action-refresh": "",
            title: _vm.$t("Lançamentos de Reserva de Fundos"),
          },
          on: { refresh: _vm.getReservedFund },
        },
        [
          _c("b-table", {
            ref: "reconciliation-reservedFund-items-table",
            staticClass: "bordered",
            attrs: {
              "show-empty": "",
              responsive: "",
              striped: "",
              "empty-text": _vm.getEmptyTableMessage(
                _vm.$tc("RECONCILIATION_ITEM.NAME"),
                "male"
              ),
              fields: _vm.fields,
              items: _vm.reconciliationReservedFundItems,
            },
            scopedSlots: _vm._u([
              {
                key: "thead-top",
                fn: function () {
                  return [
                    _c(
                      "b-tr",
                      [
                        _c(
                          "b-th",
                          { attrs: { variant: "primary", colspan: "6" } },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("Transação Stripe")) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "cell(transactionId)",
                fn: function (row) {
                  return [
                    _c("span", { attrs: { title: row.item.description } }, [
                      _vm._v(_vm._s(row.item.transactionId)),
                    ]),
                  ]
                },
              },
              {
                key: "custom-foot",
                fn: function () {
                  return [
                    _c("tr", [
                      _c("th", { attrs: { colspan: "3" } }),
                      _c("th", { staticClass: "text-right" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("currency")(_vm.stripeTotalValue)) +
                            " "
                        ),
                      ]),
                      _c("th", { staticClass: "text-right" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("currency")(_vm.stripeTotalCommission)
                            ) +
                            " "
                        ),
                      ]),
                      _c("th", { staticClass: "text-right" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("currency")(_vm.stripeTotal)) +
                            " "
                        ),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }